import React from 'react';
import { SingleDatePicker } from 'react-dates';

import './datepicker.scss';

const Datepicker = ({ input, meta, ...props }) => <SingleDatePicker {...props} small />;

export default Datepicker;
